//
//   Application Colissimo Wix
//
//   @author    BT CONSULTING - Le Studio de Tom - thomas@lestudiodetom.com
//   @copyright 2026 BT CONSULTING - Le Studio de Tom
//
// Formatage d'un montant en euros, partagé par toutes les vues qui affichent
// le tarif d'une étiquette : volet Changer le mode de livraison, volet
// Étiquettes, Bordereaux, Suivi.
//
// Centralisé pour que le même montant se lise à l'identique partout — un
// écart de séparateur ou de décimales d'une page à l'autre laisse croire à
// deux chiffres différents.

// TVA appliquée par Colissimo en France. Les montants renvoyés par l'API de
// cotation sont HT ; le TTC est calculé à l'affichage plutôt que stocké, pour
// n'avoir qu'un seul endroit à corriger si le taux change.
export const VAT_RATE = 1.2;

/**
 * Formatte un montant en € avec 2 décimales et un suffixe HT/TTC.
 *
 * `toLocaleString` respecte la locale du navigateur : virgule décimale en
 * fr-FR, espace insécable comme séparateur de milliers.
 *
 * @param {number|string|null} amount montant (null / NaN → chaîne vide)
 * @param {string} suffix 'HT' | 'TTC' | '' (mention affichée après €)
 * @returns {string} ex. « 6,90 € HT », ou '' si le montant est absent
 */
export const formatPrice = (amount, suffix = 'HT') => {
  if (amount === null || amount === undefined || isNaN(amount)) return '';
  const value = Number(amount).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return suffix ? `${value} € ${suffix}` : `${value} €`;
};

export default formatPrice;
